'use client';

import cx from 'classix';
import { useTranslations } from 'next-intl';
import { type MouseEvent } from 'react';
import { useState } from 'react';
import {
  FaFlag,
  FaHeart,
} from 'react-icons/fa6';

import { LISTINGS_TYPES } from '@/features/listing/constants/listing-constants';
import createListingBookmark from '@/features/listing/requests/create-listing-bookmark';
import deleteListingBookmark from '@/features/listing/requests/delete-listing-bookmark';
import {
  type Listing,
  type ListingType,
} from '@/features/listing/types/listing-types';
import useAppFlyerLink from '@/features/roomster-app/hooks/use-app-flyer-link';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import { useRouter } from '@/i18n/routing';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';

import styles from './listings-detail-actions.module.scss';

interface ListingDetailActionsProps {
  isBookmarked: boolean;
  listingType: ListingType;
  listingId: Listing['id'];
  onReportClick: () => void;
}

export default function ListingDetailActions(props: ListingDetailActionsProps) {
  const {
    isBookmarked,
    listingId,
    listingType,
    onReportClick,
  } = props;

  const router = useRouter();

  const actionsTranslation = useTranslations('global.actions');

  const bookmarkAppFlyerLink = useAppFlyerLink('mobile', 'mobileListingBookmark', ROUTER_LINKS.phoneAuth);
  const reportAppFlyerLink = useAppFlyerLink('mobile', 'mobileListingReport', ROUTER_LINKS.phoneAuth);

  const [isListingBookmarked,
    setIsListingBookmarked] = useState<boolean>(isBookmarked);

  const handleBookmarkClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();

    const loggedUser = getUserBearerCookie();

    if (loggedUser) {
      const currentListingTypeId = LISTINGS_TYPES[listingType];

      if (isListingBookmarked) {
        setIsListingBookmarked(false);

        deleteListingBookmark(listingId, currentListingTypeId)
          .catch(() => null);
      } else {
        setIsListingBookmarked(true);

        createListingBookmark(listingId, currentListingTypeId)
          .catch(() => null);
      }
    } else {
      router.push(bookmarkAppFlyerLink);
    }
  };

  const handleReportClick = () => {
    const loggedUser = getUserBearerCookie();

    if (loggedUser) {
      onReportClick();
    } else {
      router.push(reportAppFlyerLink);
    }
  };

  return (
    <div className={styles.listingDetailActions}>
      <button
        className={cx(
          styles.listingDetailActions_action,
          // styles.listingDetailActions_action__isDesktop,
          isListingBookmarked && styles.listingDetailActions_action__isBookmarked,
        )}
        aria-label="favorite"
        onClick={handleBookmarkClick}
      >
        <div className={styles.listingDetailActions_actionInner}>
          <FaHeart
            className={styles.listingDetailActions_actionIcon}
          />

          <p className={styles.listingDetailActions_text}>
            {isListingBookmarked ? actionsTranslation('saved') : actionsTranslation('save')}
          </p>
        </div>
      </button>

      <button
        className={cx(
          styles.listingDetailActions_action,
          // styles.listingDetailActions_action__isDesktop,
        )}
        aria-label="report"
        onClick={handleReportClick}
      >
        <div className={styles.listingDetailActions_actionInner}>
          <FaFlag
            className={styles.listingDetailActions_actionIcon}
          />

          <p className={styles.listingDetailActions_text}>{actionsTranslation('report')}</p>
        </div>
      </button>

      {/* <Link */}
      {/* className={cx( */}
      {/*   styles.listingDetailActions_action, */}
      {/*   styles.listingDetailActions_action__isMobile, */}
      {/*   isListingBookmarked && styles.listingDetailActions_action__isBookmarked, */}
      {/* )} */}
      {/* prefetch={false} */}
      {/* target="_blank" */}
      {/* href={bookmarkAppFlyerLink} */}
      {/* > */}
      {/* <div className={styles.listingDetailActions_actionInner}> */}
      {/*   <FaHeart */}
      {/*     className={styles.listingDetailActions_actionIcon} */}
      {/*   /> */}

      {/*   <p className={styles.listingDetailActions_text}> */}
      {/*     {isListingBookmarked ? actionsTranslation('saved') : actionsTranslation('save')} */}
      {/*   </p> */}
      {/* </div> */}
      {/* </Link> */}

      {/* <Link */}
      {/* className={cx( */}
      {/*   styles.listingDetailActions_action, */}
      {/*   styles.listingDetailActions_action__isMobile, */}
      {/* )} */}
      {/* prefetch={false} */}
      {/* target="_blank" */}
      {/* href={reportAppFlyerLink} */}
      {/* > */}
      {/* <div className={styles.listingDetailActions_actionInner}> */}
      {/*   <FaFlag */}
      {/*     className={styles.listingDetailActions_actionIcon} */}
      {/*   /> */}

      {/*   <p className={styles.listingDetailActions_text}>{actionsTranslation('report')}</p> */}
      {/* </div> */}
      {/* </Link> */}
    </div>
  );
}
